// API base URL is injected at build time via the REACT_APP_API_BASE_URL build arg.
// In development it defaults to '' so relative paths work with the CRA proxy.
// In production it is set to https://api.yourdomain.com in the Kamal deploy config.
const API_BASE = process.env.REACT_APP_API_BASE_URL ?? '';

export { API_BASE };
